import { type RefObject } from 'react';

import { useAppShortcut } from '@/features/shortcuts';
import { AppCapability, isCapable } from '@/utils/capabilities';

export function useRegisterAttachFileHotkey(
  inputRef: RefObject<HTMLElement | null | undefined>,
  {
    onAttachFile,
    enabled = true,
  }: {
    onAttachFile: () => void;
    enabled?: boolean;
  }
) {
  return useAppShortcut(
    'chat.attachFile',
    (event) => {
      if (!isCapable(AppCapability.HotKeys)) return;
      if (inputRef.current !== document.activeElement) return;
      event.preventDefault();
      onAttachFile();
    },
    {
      enabled,
      preventDefault: false,
      enableOnContentEditable: true,
      enableOnFormTags: true,
    },
    [onAttachFile, enabled, inputRef]
  );
}
